import _ from "lodash";
import {
  StyleTypeContext,
  TranslationContext,
  getFlag,
} from "../umbilical_tools";
import {
  ProfileBar,
  ISGLinks,
  CSTLinks,
  UnionShopperLinks,
  UBookLinks,
  SoulaLinks,
} from "./navbars/ubook";
import jssVariables from "../jss_setup";

export var redirectUrl = import.meta.env.VITE_APP_AUTH_SUCCESS_REDIRECT;
export const itemStyles = {
  display: "none",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "small",
  background: "none",
  color: jssVariables.colors.text.dark,
  textTransform: "capitalize",
  transition: "border-color .3s",
  "&:hover": {
    textDecoration: "none!important",
    "&:disabled": { cursor: "default" },
  },
  smallscreen: { fontSize: "small" },
  bigscreen: { fontSize: "large" },
};
export const menuItemStyles = {
  color: jssVariables.colors.text.light,
  display: "grid",
  gridTemplateColumns: "1fr",
  alignItems: "center",
  textAlign: "center",
  justifyItems: "center",
  fontSize: "x-large",
  fontWeight: "bold",
  textTransform: "capitalize",
};
